module.exports = __webpack_public_path__ + "img/75.1.18b88a1f.jpg";